import { createSlice } from "@reduxjs/toolkit";

interface GeneratedThemesObj {
  themeName: string,
  theme: any[]
}

const initialGeneratedThemesState: GeneratedThemesObj[] = [];

export const generatedThemesSlice = createSlice({
  name: "generatedThemes",
  initialState: initialGeneratedThemesState,
  reducers: {
    addToThemeColours: (state, action) => {
      state.push(action.payload);
    },
    removeFromThemeColours: (state, action) => {
      const index = state.indexOf(action.payload);
      state.splice(index, 1);
    },
  },
});

// Action creators are generated for each case reducer function
export const { addToThemeColours, removeFromThemeColours } =
generatedThemesSlice.actions;

export default generatedThemesSlice.reducer;

